"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormRichEditor = void 0;
const rich_editor_1 = require("../../../components/rich-editor/rich-editor");
const form_field_1 = require("./form-field");
exports.FormRichEditor = form_field_1.formFieldFactory(rich_editor_1.RichEditor);
//# sourceMappingURL=form-rich-editor.js.map